export const GET_MANUFACTURERS_REQUEST = 'GET_MANUFACTURERS_REQUEST';
export const GET_MANUFACTURERS_SUCCESS = 'GET_MANUFACTURERS_SUCCESS';
